import { IMotoristaDetalhes, IVeiculoDetalhes } from '../agendamentos/types';

export enum ConsultaAgendamentosTypes {
  'LOAD_REQUEST' = '@consultaAgendamentos/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@consultaAgendamentos/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@consultaAgendamentos/LOAD_FAILURE',

  'FILTER_AGEMDAMEMTOS' = '@consultaAgendamentos/FILTER_AGEMDAMEMTOS',
}

export interface IConsultaAgendamentos {
  codVeiculo: number;
  placa: string;
  centroDistribuicao: string;
  cliente: string;
  codAgendamento: number;
  codCentroDistribuicao: number;
  codEmp: number;
  codCliente: number;
  codHorario: number;
  codMotorista: number;
  ordemCarga: number;
  codPlataforma: number;
  plataforma: string;
  codTransportadora: number;
  cpfMotorista: string;
  dhAgendamento: string;
  fimPrevisto: string;
  motorista: string;
  pesoBruto: number;
  status: string;
  transportadora: string;
  valor: number;
  tipoWms: string;
  dhChegada: string;
  dhEntrada: string;
  dhSaida: string;
  dhIniOper: string;
  dhFinOper: string;
  listaNf: number[];
  dhAguardando: string;
  dhFim: string;
  assoalho: string;
  dhAgendado: string;
  duracao: number;
  clienteRetira: boolean;
  temAnexo: boolean;
  detalheVeiculo: IVeiculoDetalhes;
  detalheMotorista: IMotoristaDetalhes;
  codTipoCarroceria: number;
  tipoCarga: string;
  volume: string;
}

export interface IFitroAgendamentos {
  dtAgendamento: string | Date;
}

export interface ConsultaAgendamentosState {
  readonly data: IConsultaAgendamentos[];
  readonly total: {
    total: number;
    totAgendado: number;
    totExpedido: number;
    totEntrega: number;
    totColeta: number;
    tAgeEntrega: number;
    tAgeColeta: number;
    tExpEntrega: number;
    tExpColeta: number;
    totFerro: number;
    totMadeira: number;
    qtdPlat: number;
  };
  readonly loading: boolean;
  readonly error: boolean;
  readonly filter?: IFitroAgendamentos | undefined;
}
